import { useCallback, useEffect, useState } from "react";

import { useNavigate, useSearchParams } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";

import LeftChevron from "../../../../assets/images/chevron-left-color.svg";

import ProgressBar from "../../../../shared/LinearProgressBar";

import Button from "../ButtonComponent";

import HeaderModule from "../ModuleHeaderComponent";
import CourseStatusModal from "../CourseStatusModal";

import QuestionCards from "../QuestionCards";

import Shimmer from "../ShimmerComponent";

import { useSavePostCourseAssessment } from "./mutation";

import { BUTTON_VARIANTS } from "../constant";

import { useGetPostAssessmentQuestion } from "./queries";

import styles from "./styles.module.scss";
import AssessmentExitModal from "../AssessmentExitModal";

import { ASSESSMENT_ALLOWED, COURSE_MARKS, FEEDBACK_ALLOWED, IS_RETAKE_ATTEMPT } from "../../../../utils/cookiesmanager";
import CourseRetakeStatusModal from "../CourseRetakeStatusModal";
import { useGetTranslatedText } from "../queries";
import { getTranslatedText } from "../../../../utils/getTranslatedText";

const PostCourseAssessment = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animate, setAnimate] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState({});
  const [isFinished, setIsFinished] = useState(false);
  const [questionResponse, setQuestionResponse] = useState({});
  const [allowLeave, setAllowLeave] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const courseId = searchParams.get("courseId");
  const courseName = searchParams.get("courseName");

  const languageId = localStorage.getItem("l_id") || 1;
  
  const {data:translatedTextResponse} = useGetTranslatedText(languageId)
          
  const {data:translatedText = []} = translatedTextResponse || {};
  
  const { data: postAssessmentQuestion, isLoading } =
    useGetPostAssessmentQuestion({
      courseId,
      languageId,
    });

  const { mutate } = useSavePostCourseAssessment();

  const { data: postAssessmentQuestionData } = postAssessmentQuestion || {};

  const { response } = postAssessmentQuestionData || {};

  const handleSubmit = () => {
    const currentQuestion = response?.[activeIndex];

    if (!selectedAnswer[currentQuestion?.assQuestionId]) {
      toast.error("Please select an answer");
      return;
    }

    if (activeIndex === response?.length - 1) {
      const payload = {
        courseId: courseId,
        questionArray: Object.entries(selectedAnswer).map(
          ([assQuestionID, answerData]) => ({
            assQuestionID: String(assQuestionID),
            assAnswerID: String(answerData.assessmentAnswerId),
          }),
        ),
      };

      setIsFinished(true);

      mutate(payload, {
        onSuccess(data) {
          const { status, error } = data;

          setQuestionResponse(data?.data?.response);

          localStorage.setItem(COURSE_MARKS,data?.data?.response?.percentage)

          if (!status) {
            throw new Error(error);
          }
          setIsFinished(true);
        },
        onError(error) {
          // const errorMessage =
          //   error instanceof Error ? error.message : String(error);
          const serverMessage = error?.response?.data?.message;
        const finalMsg =
          serverMessage || error?.message || "Something went wrong";
          
        toast.error(finalMsg);
        },
        onSettled() {},
      });
      return;
    }

    setAnimate(true);
    // setTimeout(() => {
      setAnimate(false);
      setActiveIndex((prev) => prev + 1);
    // }, 400);
  };

  const handleContinue = () => {
    const isFeedbackCompleted = localStorage.getItem(FEEDBACK_ALLOWED);

    setIsFinished(false);

    if(isFeedbackCompleted === '1'){
      navigate(`/user/course`,{replace:true});
      return;
    }
   
    navigate(`/user/post-course-feedback?courseId=${courseId}`);
  };

  const handleTryAgain = () => {
    const isRetakeAttempt = localStorage.getItem(IS_RETAKE_ATTEMPT);
    
    if(JSON.parse(isRetakeAttempt)){
    navigate(
     `/user/module-list?courseId=${courseId}&courseName=${courseName}`,
     {replace:true}
    );

    return;
    }
    setIsFinished(false);
    setSelectedAnswer({});
    setActiveIndex(0);
    navigate(`/user/post-course-assessment?courseId=${courseId}&courseName=${courseName}`);
  };

  const handlePreviousClick = () => {
    if (activeIndex === 0 || activeIndex < 0) return;

    // setAnimate(true);

    // setTimeout(() => {
      // setAnimate(false);
      setActiveIndex((prev) => prev - 1);
    // }, 500);
  };

  const handleQuestionAnswer = useCallback((question, option) => {
    setSelectedAnswer((prev) => ({
      ...prev,
      [question?.assQuestionId]: {
        courseId: courseId,
        languageId: 1,
        assessmentId: question?.assessmentId,
        assessmentQuestionId: question?.assQuestionId,
        assessmentAnswerId: option?.assAnswerId,
      },
    }));
  }, []);

  const handleBack = () => {
    setShowWarning(true);
  };

  const handleContinueAssessment = () => {
    setShowWarning(false);
    setAllowLeave(false);
  };

  const handleExit = () => {
    sessionStorage.removeItem(ASSESSMENT_ALLOWED);
    navigate(
     `/user/module-list?courseId=${courseId}&courseName=${courseName}`,
     {replace:true}
    );
  };

  useEffect(() => {
            // Add a dummy history entry
      window.history.pushState({ guard: true }, "", `${window.location.pathname}?${searchParams.toString()}`);
        
        const handlePopState = () => {
              if (!allowLeave) {
                setShowWarning(true);
        
                // Re-push state to stop navigation
                window.history.pushState(
                  { guard: true },
                  "",
                  window.location.pathname
                );
              }
            };
        
            window.addEventListener("popstate", handlePopState);
        
        return () => {
              window.removeEventListener("popstate", handlePopState);
        };
    },[allowLeave])

    useEffect(() => {
      const allowed = sessionStorage.getItem(ASSESSMENT_ALLOWED);
    
      if (!allowed) {
        navigate(
          `/user/module-list?courseId=${courseId}&courseName=${courseName}`,
          {replace:true}
        );
      }
    }, []);

    const handleCourseExit = () => {
       navigate(
          `/user/module-list?courseId=${courseId}&courseName=${courseName}`,
          {replace:true}
        );
    }

  const isFirstQuestion = activeIndex === 0;
  const isLastQuestion = response && activeIndex === response?.length - 1;

  const currentQuestionId = response?.[activeIndex]?.assQuestionId;

  const isOptionSelected = Boolean(selectedAnswer[currentQuestionId]);

  const isRetakeAttempt = localStorage.getItem(IS_RETAKE_ATTEMPT);

  const isTryAgainOptionAvailable = JSON.parse(isRetakeAttempt) ? true :  false;

  return (
    <>
      <div className={styles.page}>
        <HeaderModule
          title={getTranslatedText(translatedText ,"key_post_course" , "Post-Course Assessment")}
          className={styles["header-title"]}
          onBackClick={handleBack}
        />
        <div className={styles["container-wrapper"]}>
          <div className={styles["content-part"]}>
            <p className={styles.title}>{courseName || ''}</p>
            <ProgressBar current={activeIndex} total={response?.length} />
            {isLoading ? (
              <Shimmer width="90%" height="324px" borderRadius="14px" />
            ) : (
              <QuestionCards
                selectedAnswer={selectedAnswer[currentQuestionId]}
                questionsList={response}
                handleQuestionAnswer={handleQuestionAnswer}
                activeIndex={activeIndex}
                animate={animate}
              />
            )}
          </div>
        </div>
        <div className={styles["bottom-wrapper"]}>
          <Button
            label={getTranslatedText(translatedText, "key_previous","Previous")}
            buttonVariant={BUTTON_VARIANTS.SECONDARY}
            startIcon={<img src={LeftChevron} alt="previous" />}
            className={styles["button-class"]}
            onClick={handlePreviousClick}
            disabled={isFirstQuestion || activeIndex === 0 || activeIndex < 0}
          />
          <Button
            label={isLastQuestion ? getTranslatedText(translatedText, "key_submit","Submit")  : getTranslatedText(translatedText, "label_next","Next")}
            buttonVariant={BUTTON_VARIANTS.PRIMARY}
            className={styles["button-class"]}
            onClick={handleSubmit}
            disabled={!isOptionSelected}
          />
        </div>
        <ToastContainer />
      </div>
      {isFinished && (
        isTryAgainOptionAvailable
        ?
        <CourseRetakeStatusModal           
          marks={questionResponse}
          show={isFinished}
          handleContinue={handleContinue}
          handleTryAgain={handleContinue}
          passingMarks={60} 
          />
        :
        <CourseStatusModal
          marks={questionResponse}
          show={isFinished}
          handleContinue={handleContinue}
          handleTryAgain={handleTryAgain}
          handleExit={handleCourseExit }
          passingMarks={60}
        />
      )}
      {showWarning && <AssessmentExitModal handleContinueAssessment={handleContinueAssessment} handleExit={handleExit} show={showWarning} />}
    </>
  );
};

export default PostCourseAssessment;